/**
 * Search overlay — abrir/cerrar, pills de busqueda popular, y busqueda en
 * vivo vía la Predictive Search API nativa de Shopify (sustituye el
 * endpoint AJAX custom del tema WP original).
 */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-search-overlay]');
  var scrim = document.querySelector('[data-search-overlay-scrim]');
  var openBtn = document.querySelector('[data-search-toggle]');
  var closeBtn = document.querySelector('[data-search-overlay-close]');
  var input = document.querySelector('[data-search-input]');
  var clearBtn = document.querySelector('[data-search-clear]');
  var defaultContent = document.querySelector('[data-search-default-content]');
  var resultsEl = document.querySelector('[data-search-results]');
  var resultsCountEl = document.querySelector('[data-search-results-count]');
  var resultsViewAllEl = document.querySelector('[data-search-results-view-all]');
  var resultsGridEl = document.querySelector('[data-search-results-grid]');
  var SEARCH_LIMIT = 10;
  var PLUS_ICON =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="miter" aria-hidden="true"><line x1="12" y1="4" x2="12" y2="20"/><line x1="4" y1="12" x2="20" y2="12"/></svg>';

  if (!overlay || !input) return;

  function openOverlay() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    overlay.inert = false;
    if (scrim) scrim.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () { input.focus(); }, 50);
  }

  function closeOverlay() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.inert = true;
    if (scrim) scrim.hidden = true;
    document.body.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', openOverlay);
  if (closeBtn) closeBtn.addEventListener('click', closeOverlay);
  if (scrim) scrim.addEventListener('click', closeOverlay);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeOverlay();
  });

  // Popular search pills — fill input and trigger a search
  document.querySelectorAll('[data-search-pill]').forEach(function (pill) {
    pill.addEventListener('click', function () {
      input.value = pill.dataset.searchPill;
      input.dispatchEvent(new Event('input'));
    });
  });

  function renderResults(products, query) {
    if (resultsViewAllEl) {
      resultsViewAllEl.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
    }

    if (!products.length) {
      if (resultsCountEl) resultsCountEl.textContent = '';
      if (resultsViewAllEl) resultsViewAllEl.hidden = true;
      resultsGridEl.innerHTML = '<p class="search-overlay__no-results">No results found.</p>';
      return;
    }

    if (resultsCountEl) {
      resultsCountEl.textContent =
        (products.length >= SEARCH_LIMIT ? '+' : '') + products.length + ' result' + (products.length === 1 ? '' : 's');
    }
    if (resultsViewAllEl) resultsViewAllEl.hidden = false;

    resultsGridEl.innerHTML = products
      .map(function (p) {
        // srcset real (no un solo ancho fijo) — el overlay no tiene
        // max-width, en desktop cada card puede rondar los 400-450px de
        // ancho, mucho mas que los ~150px de movil. Sin esto, escritorio
        // pedia siempre la misma imagen de 300px y se veia borrosa.
        var img = p.image
          ? '<img class="search-result-card__photo" src="' + p.image + '&width=600" ' +
            'srcset="' + p.image + '&width=300 300w, ' + p.image + '&width=600 600w, ' + p.image + '&width=900 900w" ' +
            'sizes="(min-width: 640px) 22vw, 45vw" alt="" loading="lazy">'
          : '';
        return (
          '<a href="' + p.url + '" class="search-result-card">' +
          '<div class="search-result-card__img">' +
          img +
          '<span class="search-result-card__quick-btn">' + PLUS_ICON + '</span>' +
          '</div>' +
          '<p class="search-result-card__name">' + p.title + '</p>' +
          '<p class="search-result-card__price">' + p.price + '</p>' +
          '</a>'
        );
      })
      .join('');
  }

  var searchTimer = null;

  function doSearch(query) {
    if (!query) {
      defaultContent.hidden = false;
      resultsEl.hidden = true;
      return;
    }

    fetch(themeApiRoot() + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=' + SEARCH_LIMIT + '&resources[options][unavailable_products]=last')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        defaultContent.hidden = true;
        resultsEl.hidden = false;
        renderResults(
          products.map(function (p) {
            return { url: p.url, image: p.featured_image ? p.featured_image.url : '', title: p.title, price: p.price };
          }),
          query
        );
      })
      .catch(function () {});
  }

  input.addEventListener('input', function () {
    var value = input.value.trim();
    if (clearBtn) clearBtn.hidden = value === '';
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () { doSearch(value); }, 300);
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', function () {
      input.value = '';
      clearBtn.hidden = true;
      defaultContent.hidden = false;
      resultsEl.hidden = true;
      input.focus();
    });
  }
})();
